import { render, staticRenderFns } from "./SettingsMaterialsCategory.vue?vue&type=template&id=92bf5e6e&scoped=true&"
import script from "./SettingsMaterialsCategory.vue?vue&type=script&lang=js&"
export * from "./SettingsMaterialsCategory.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMaterialsCategory.vue?vue&type=style&index=0&id=92bf5e6e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bf5e6e",
  null
  
)

export default component.exports